import React from 'react';
import { Checkbox } from 'react-bootstrap';

export default class Checkboxes extends React.Component {
	constructor(props) {
		super(props);

		this.state = { data: this.props.data, actual_data: this.props.actual_data }
	}

	onChange(evt) {

		let actual_data = this.state.actual_data;

		const dataID = parseInt(evt.target.value, 10);
		if (evt.target.checked) {
			actual_data.push(dataID);
		} else {
			actual_data.splice(actual_data.indexOf(dataID), 1);
		}

		this.setState({ actual_data });
	}

	componentWillUpdate(nextProps, nextState) {
		this.props.callback(nextState.actual_data);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ data: nextProps.data, actual_data: nextProps.actual_data });
	}

	render() {
		let checkboxes = this.state.data.map(function (item) {
			const checked = this.state.actual_data.indexOf(item.id) !== -1;
			return (
				<Checkbox value={item.id} key={item.id} checked={checked} onChange={this.onChange.bind(this)}>
					{item.name}
				</Checkbox>
			)
		}.bind(this));
		return (<div>{checkboxes}</div>);
	}

}


// WEBPACK FOOTER //
// ./src/modules/base/Checkboxes.js